import { AxiosInstance } from 'axios';
import { getExportConfig, handleFileExport } from '../../../../../../helpers/fileExport';
import { IN_HOUSE_REPORT_ENDPOINT } from '../endpoint';
import { InHouseReportRequestModel } from '../models/InHouseReportRequestModel';

export const exportPDF =
  (axios: AxiosInstance) =>
  async (params?: InHouseReportRequestModel): Promise<void> => {
    return await axios
      .get(`${IN_HOUSE_REPORT_ENDPOINT}`, {
        params: { ...params },
        ...getExportConfig(params),
      })
      .then(response => {
        handleFileExport(response, {
          file_type: params?.file_type,
          filename: 'in-house-report',
        });
      });
  };
